import React from 'react';
import './Footer.css'
import { FaHeart, FaEnvelope, FaClock } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        {/* Logo & Description */}
        <div className="footer-section">
          <FaHeart className="footer-icon heart-icon" />
          <h2>About Us!</h2>
          <p>
          We provide compassionate pet cremation and burial services, ensuring a dignified farewell for your beloved companions.


          </p>
        </div>

        {/* Contact Section */}
        <div className="footer-section">
          <FaEnvelope className="footer-icon" />
          <h3>Contact Us</h3>
          <p>6304692989</p>
          <p>9160383791</p>
          <p>Email: <span className="email-text">petburialvijayawada@gmail.com</span></p>
        </div>

        {/* Working Hours */}
        <div className="footer-section">
          <FaClock className="footer-icon" />
          <h3>Address </h3>
          <p>41-30/1-49, Krishna Lanka, </p>
          <p> Vijayawada, PIN: 520013</p>


        </div>
      </div>

      {/* Copyright Section */}
      <div className="footer-bottom">
        <p>Copyright 2024 / Designed by <span className="designer">PET-CREMATION</span></p>
      </div>
    </footer>
  );
};

export default Footer;
